let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fgjrS")).then(() => parcelRequire('3mMPp'));